import { Flex, Image, Typography } from "@jewlr/storybook/core"
import React from "react"

import SampleCertLink from "areas/product/diamond-selector/sample-cert-link"

const AboutDiamonds = () => (
  <div>
    <Flex alignItems="center" justifyContent="center" mb={2}>
      <Image
        alt="Jewlr"
        height="16px"
        mr="4px"
        src={require("images/layout/logo/jewlr-icon-logo-primary.svg")}
        width="16px"
      />
      <Typography as="h5" bold fontSize={16}>
        &quot;The One&quot;
      </Typography>
    </Flex>
    <Typography mb={3}>
      The One indicates diamonds that have been selected for their combinations
      of color, clarity and cut, resulting in the most beautiful diamonds and
      best value.
    </Typography>
    <Typography mb={3}>
      Want something more personal? Use our “Select Your own” step-by-step guide
      to find your perfect stone. Our certified gemologists and diamond buyers
      have worked extensively to offer you a wide selection of diamonds to suit
      your needs.
    </Typography>
    <Image
      alt="Certified by the GIA, IGI or GSL"
      mb={2}
      ratio="190 / 23"
      src={`${sl.config.jewlr_asset_url}images/product/diamond/gemlabs.svg`}
      width="200px"
    />
    <Typography mb={2}>
      All diamonds are certified by the GIA, IGI or GSL. A diamond certificate
      will be sent to you with your ring.
    </Typography>
    <SampleCertLink />
  </div>
)

export default AboutDiamonds
